import { render, staticRenderFns } from "./HorizontalQuestionnaire.vue?vue&type=template&id=686cc438&scoped=true&lang=pug"
import script from "./HorizontalQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./HorizontalQuestionnaire.vue?vue&type=script&lang=ts"
import style0 from "./HorizontalQuestionnaire.vue?vue&type=style&index=0&id=686cc438&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686cc438",
  null
  
)

export default component.exports